import { IQueryFeaturesOptions } from '@esri/arcgis-rest-feature-layer';

import { Geometry } from '../types';

export interface IQueryOptions extends Omit<IQueryFeaturesOptions, 'url' | 'f'> {
  geometry?: Geometry;
}
